import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import Placeholder from '../../components/Placeholder';
import Markdown from '../../components/Markdown';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import {
  Section,
  Inner,
  Title,
  Description,
  List,
  Labels,
  Region,
  Address,
  Email,
  Phone,
  Item,
} from './ContactUsPage.style';

const ContactUsPage = ({ data, locale }) => (
  <React.Fragment>
    {_.get(data, 'metaData') && (
      <Helmet
        title={_.get(data.metaData, 'title')}
        link={[makeCanonicalTagObj(locale, '/contact-us'), ...makeHreflangTagArr(data.metaData.region, '/contact-us')]}
        meta={[
          {
            name: 'description',
            content: _.get(data.metaData, 'description'),
          },
          {
            name: 'keyword',
            content: _.get(data.metaData, 'keyword'),
          },
          // TODO: OGP タグは一旦保留 (2020年01月07日)
          // {
          //   property: 'og:url',
          //   content: _.get(data.metaData, 'url'),
          // },
          // {
          //   property: 'og:type',
          //   content: _.get(data.metaData, 'type'),
          // },
          // {
          //   property: 'og:title',
          //   content: _.get(data.metaData, 'title'),
          // },
          // {
          //   property: 'og:image',
          //   content: _.get(data.metaData, 'image.file.url'),
          // },
          // {
          //   property: 'og:description',
          //   content: _.get(data.metaData, 'description'),
          // },
          // {
          //   property: 'og:site_name',
          //   content: _.get(data.metaData, 'siteName'),
          // },
        ]}
      />
    )}
    <Section>
      <Inner>
        <Title>{data.title || <Placeholder w="200px" h="30px" />}</Title>
        {data.description && data.description !== '' ? <Markdown src={data.description} Component={Description} /> : null}
        <List>
          <Labels>
            <Region />
            <Address />
            <Email>{data.copy.email_us || <Placeholder w="100px" h="15px" />}</Email>
            <Phone>{data.copy.call_us || <Placeholder w="100px" h="15px" />}</Phone>
          </Labels>

          {data.list.map(item => (
            <Item key={item.region || item.key}>
              <Region>{item.region || (data.notLoaded && <Placeholder w="100px" h="40px" />)}</Region>
              <Address>{item.address || (data.notLoaded && <Placeholder w="200px" h="40px" />)}</Address>
              <Email>{item.email || (data.notLoaded && <Placeholder w="200px" h="40px" />)}</Email>
              <Phone>{item.phone || (data.notLoaded && <Placeholder w="150px" h="40px" />)}</Phone>
            </Item>
          ))}
        </List>
      </Inner>
    </Section>
    {locale && (
      <BreadCrumbMenu
        currentPath={`https://www.shiseido-professional.com/${locale}/contact-us`}
        items={[
          {
            name: 'TOP',
            path: `/${locale}/`,
          },
          {
            name: 'ABOUT US',
            path: `/${locale}/about/`,
          },
          {
            name: 'CONTACT US',
            path: null,
          },
        ]}
      />
    )}
  </React.Fragment>
);

ContactUsPage.defaultProps = {
  data: {
    copy: {},
    notLoaded: true,
    list: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }, { key: 5 }, { key: 6 }, { key: 7 }],
  },
};

ContactUsPage.propTypes = {
  locale: PropTypes.string.isRequired,
  data: PropTypes.shape({
    copy: PropTypes.shape(),
    title: PropTypes.string,
    description: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.shape()),
    notLoaded: PropTypes.bool,
  }),
};

export default ContactUsPage;



// WEBPACK FOOTER //
// ./src/pages/ContactUsPage/ContactUsPage.js